import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import CircularProgress from "@material-ui/core/CircularProgress";
// import InputAdornment from "@material-ui/core/InputAdornment";
import DialogContentText from "@material-ui/core/DialogContentText";
import TournamentDetailsContainer from "../../containers/settings/TournamentDetailsContainer";

export default class InAppDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.showInApp}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText>
              <Typography variant="caption">
                {languages.present.showInAppDescription}
              </Typography>
            </DialogContentText>
            <TournamentDetailsContainer tournament={this.props.tournament} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <div style={{ position: "relative" }}>
              <Button
                onClick={this.props.handleSubmit}
                variant="contained"
                color="primary"
                type="submit"
                disabled={
                  this.props.addingToApp ||
                  this.props.tournament.sportId === undefined ||
                  this.props.tournament.sportId === null ||
                  (this.props.tournament.gender || []).length === 0 ||
                  this.props.tournament.level === undefined ||
                  this.props.tournament.country === undefined
                }
              >
                {languages.general.save}
              </Button>
              {this.props.addingToApp && (
                <CircularProgress
                  size={24}
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: -12,
                    marginLeft: -12,
                  }}
                />
              )}
            </div>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
